import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import SEOHead from '@/components/feature/SEOHead';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/feature/Breadcrumb';
import ComicCard from '@/components/feature/ComicCard';
import { comics, categories } from '@/mocks/comics';

export default function CategoryPage() {
  const { slug } = useParams<{ slug: string }>();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'instant' });
  }, [slug]);

  const currentCategory = categories.find((c) => c.slug === slug);
  const categoryName = currentCategory?.name || '全部';

  const filteredComics =
    slug === 'all' ? comics : comics.filter((c) => c.category === slug);

  const catDescription =
    slug === 'all'
      ? '浏览无遮韩国免费漫画大全的全部漫画资源，涵盖恋爱、奇幻、热血、搞笑、悬疑等多种类型，全部免费在线阅读。'
      : `在无遮韩国免费漫画大全浏览${categoryName}类韩漫，精选高质量${categoryName}题材韩国漫画，全部免费在线阅读，每日更新。`;

  return (
    <>
      <SEOHead
        title={`${categoryName}漫画`}
        description={catDescription}
        keywords={`${categoryName}韩漫,${categoryName}漫画,免费${categoryName}漫画,韩漫漫画网站,无遮韩国免费漫画大全`}
        canonicalUrl={`/category/${slug}`}
      />

      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main className="pt-20">
          <div className="w-full px-4 md:px-6 py-6">
            <div className="max-w-7xl mx-auto">
              <Breadcrumb
                items={[
                  { label: '首页', href: '/' },
                  { label: `${categoryName}漫画` },
                ]}
              />
            </div>
          </div>

          <div className="w-full px-4 md:px-6 py-4">
            <div className="max-w-7xl mx-auto">
              <div className="flex items-center gap-2 overflow-x-auto pb-3 flex-wrap">
                {categories.map((cat) => (
                  <a
                    key={cat.slug}
                    href={cat.slug === 'all' ? '/category/all' : `/category/${cat.slug}`}
                    className={`flex items-center gap-1.5 px-4 py-2 rounded-full text-sm whitespace-nowrap transition-all duration-200 no-underline cursor-pointer ${
                      slug === cat.slug
                        ? 'bg-primary-500 text-background-50 font-medium'
                        : 'bg-background-100 text-foreground-600 hover:bg-background-200 hover:text-foreground-900'
                    }`}
                  >
                    <i className={`${cat.icon} text-sm`}></i>
                    {cat.name}
                  </a>
                ))}
              </div>
            </div>
          </div>

          <div className="w-full px-4 md:px-6 py-6">
            <div className="max-w-7xl mx-auto">
              <div className="mb-6">
                <h1 className="text-xl md:text-2xl font-heading font-bold text-foreground-950">
                  {categoryName}漫画
                </h1>
                <p className="text-sm text-foreground-500 mt-1">
                  共 {filteredComics.length} 部作品
                </p>
              </div>

              {filteredComics.length > 0 ? (
                <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4 md:gap-5">
                  {filteredComics.map((comic) => {
                    const cat = categories.find((c) => c.slug === comic.category);
                    return (
                      <ComicCard
                        key={comic.id}
                        id={comic.id}
                        title={comic.title}
                        slug={comic.slug}
                        category={comic.category}
                        coverImage={comic.coverImage}
                        rating={comic.rating}
                        views={comic.views}
                        chapters={comic.chapters}
                        status={comic.status}
                        tags={comic.tags}
                        categoryName={cat?.name}
                      />
                    );
                  })}
                </div>
              ) : (
                <div className="text-center py-20">
                  <p className="text-foreground-500">暂无该分类的漫画内容</p>
                </div>
              )}
            </div>
          </div>
        </main>
        <Footer />
      </div>
    </>
  );
}